

const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000001';

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock 2-Plate Horizontal Bundle',
  Version: 1,
  ProductTypeId: 97,
  Sku: null,
  Surface: null,
  Matrix: { Rows: 1, Columns: 6, Segments: null },
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'frame-a-001',
      Type: 'Frame',
      Sku: 329930935,
      Name: '20 in. x 30.75 in. Wall Plate in Black',
      ChoiceId: 265405,
      Origin: { Row: 0, Column: 0, Height: 2000, Width: 3075 },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: ['accessory-001'],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'frame-b-001',
      Type: 'Frame',
      Sku: 329930935,
      Name: '20 in. x 30.75 in. Wall Plate in Black',
      ChoiceId: 265405,
      Origin: { Row: 0, Column: 300, Height: 2000, Width: 3075 },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: ['accessory-001', 'accessory-002'],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'accessory-001',
      Type: 'Accessory',
      Sku: 320324795,
      Name: 'PACKOUT 19.5 in. Cabinet in Red',
      ChoiceId: 265425,
      Origin: { Row: 500, Column: 2500, Height: 1470, Width: 1950 },
      ParentIds: ['frame-a-001', 'frame-b-001'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp2-r0-c0' } },
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'accessory-002',
      Type: 'Hook',
      Sku: 320026102,
      Name: 'PACKOUT Straight Utility Hook',
      ChoiceId: 265424,
      Origin: { Row: 1100, Column: 1400, Height: 800, Width: 350 },
      ParentIds: ['frame-b-001'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp1-r1-c0' } },
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const wallStorageBundleMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default wallStorageBundleMock;
